module.exports = __webpack_public_path__ + "static/media/135-belarus.67b29043.svg";